import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "change-plan" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "price-difference-wrapper"
}
const _hoisted_6 = { class: "plan-name" }
const _hoisted_7 = { class: "plan-price" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 5,
  class: "error-message"
}
const _hoisted_11 = { class: "issue-list" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "button-wrapper" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_BasePopup = _resolveComponent("BasePopup")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_gs_button = _resolveComponent("gs-button")!
  const _component_FullWidthPanel = _resolveComponent("FullWidthPanel")!
  const _component_StepperContent = _resolveComponent("StepperContent")!
  const _component_SelectCustomSpendingLimit = _resolveComponent("SelectCustomSpendingLimit")!
  const _component_ConfirmCustomSpendingLimit = _resolveComponent("ConfirmCustomSpendingLimit")!
  const _component_CustomSpendingLimitSuccess = _resolveComponent("CustomSpendingLimitSuccess")!
  const _component_Stepper = _resolveComponent("Stepper")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(_component_BasePopup, {
          modelValue: _ctx.isCancelChangePlanPopupOpen,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCancelChangePlanPopupOpen) = $event)),
          "primary-button-action": () => (_ctx.isCancelChangePlanPopupOpen = false),
          "secondary-button-action": () => _ctx.$emit('close'),
          title: _ctx.t('cancel_upgrade_alert_title'),
          "primary-button-text": _ctx.t('continue_upgrade'),
          "secondary-button-text": _ctx.t('cancel_upgrade')
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: 
            _ctx.t('cancel_upgrade_alert_description', {
              currentPlan: _ctx.currentPlanType && _ctx.getPlanName(_ctx.currentPlanType),
              selectedPlan: _ctx.selectedPlanType && _ctx.getPlanName(_ctx.selectedPlanType),
            })
          
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }, 8, ["modelValue", "primary-button-action", "secondary-button-action", "title", "primary-button-text", "secondary-button-text"]),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_Stepper, {
          modelValue: _ctx.activeStep,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeStep) = $event)),
          "max-value": 3,
          "show-logo": false,
          "show-stepper": 
        (_ctx.currentStore?.spendingLimit?.activeLimit && _ctx.hasShopifyPaymentDetails) ||
        _ctx.account.userFromMarketplace
      
        }, {
          default: _withCtx(() => [
            _createVNode(_component_StepperContent, {
              "is-visible": _ctx.activeStep === 1
            }, {
              default: _withCtx(() => [
                (!_ctx.isCustomSpendingLimitSetupFinished)
                  ? (_openBlock(), _createBlock(_component_FullWidthPanel, {
                      key: 0,
                      title: _ctx.isUpgrade ? _ctx.t('upgrade_title') : _ctx.t('downgrade_title')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          (_ctx.isUpgrade)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: "upgrade-text",
                                innerHTML: 
                _ctx.t(_ctx.isTrial ? 'upgrade_from_trial.subtitle' : 'upgrade.subtitle', {
                  currentPlan: _ctx.currentPlanType && _ctx.getPlanName(_ctx.currentPlanType),
                  selectedPlan: _ctx.selectedPlanType && _ctx.getPlanName(_ctx.selectedPlanType),
                })
              
                              }, null, 8, _hoisted_3))
                            : (_openBlock(), _createElementBlock("p", {
                                key: 1,
                                class: "upgrade-text",
                                innerHTML: 
                _ctx.t(
                  _ctx.isTrial ? 'downgrade_from_trial.subtitle' : 'downgrade.subtitle',
                  _ctx.currentPlanType &&
                    _ctx.selectedPlanType && {
                      currentPlan: _ctx.getPlanName(_ctx.currentPlanType),
                      selectedPlan: _ctx.getPlanName(_ctx.selectedPlanType),
                    },
                )
              
                              }, null, 8, _hoisted_4)),
                          (_ctx.selectedPlanType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getPlanName(_ctx.selectedPlanType)) + " " + _toDisplayString(_ctx.t('plan')), 1),
                                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.displayPrice), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.isUpgrade)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 3,
                                class: "upgrade-disclaimer",
                                innerHTML: 
                _ctx.t(
                  _ctx.isTrial
                    ? _ctx.isSelectedPlanYearly
                      ? 'upgrade_from_trial.disclaimer_per_year'
                      : 'upgrade_from_trial.disclaimer_per_month'
                    : 'upgrade.disclaimer',
                  {
                    totalAmount: _ctx.displayPrice,
                  },
                )
              
                              }, null, 8, _hoisted_8))
                            : (_openBlock(), _createElementBlock("p", {
                                key: 4,
                                class: "upgrade-disclaimer",
                                innerHTML: 
                _ctx.t(
                  _ctx.isTrial
                    ? _ctx.isSelectedPlanYearly
                      ? 'downgrade_from_trial.disclaimer_per_year'
                      : 'downgrade_from_trial.disclaimer_per_month'
                    : 'downgrade.disclaimer',
                  {
                    totalAmount: _ctx.displayPrice,
                  },
                )
              
                              }, null, 8, _hoisted_9)),
                          (_ctx.isDowngradeDisabled)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("ul", _hoisted_11, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downgradeIssues, ({ issue, currentAmount, maxAmount }, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: index,
                                      class: "issue-list-item"
                                    }, [
                                      _createVNode(_component_v_icon, {
                                        size: "24px",
                                        class: "issue-icon"
                                      }, {
                                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                                          _createTextVNode(" mdi-information-outline ")
                                        ])),
                                        _: 1
                                      }),
                                      _createElementVNode("div", null, _toDisplayString(_ctx.t(_ctx.snakeCase(issue), { currentAmount, maxAmount })), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.isDowngradeDisabled)
                            ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                key: 6,
                                modelValue: _ctx.checkbox,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkbox) = $event)),
                                color: "green",
                                "hide-details": "",
                                rules: [_ctx.rules.required],
                                class: "terms-checkbox"
                              }, {
                                label: _withCtx(() => [
                                  _createVNode(_component_i18n_t, {
                                    tag: "p",
                                    keypath: "Signup.accept",
                                    class: "terms"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("a", {
                                        href: _ctx.TERMS_CONDITIONS_URL,
                                        target: "_blank",
                                        class: "link"
                                      }, _toDisplayString(_ctx.t('terms')), 9, _hoisted_12),
                                      _createElementVNode("a", {
                                        href: _ctx.PRIVACY_POLICY_URL,
                                        target: "_blank",
                                        class: "link"
                                      }, _toDisplayString(_ctx.t('privacy')), 9, _hoisted_13)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_gs_button, {
                              onClick: _ctx.navigateBack,
                              icon: "mdi-chevron-left",
                              size: "large",
                              type: "outlined"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('CommonUi.back')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_gs_button, {
                              type: "primary",
                              size: "large",
                              "full-width": "",
                              disabled: !_ctx.checkbox || _ctx.changePlanLoading || _ctx.isDowngradeDisabled,
                              loading: _ctx.changePlanLoading,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handlePlanChange()))
                            }, {
                              default: _withCtx(() => [
                                (_ctx.isUpgrade)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.isTrial ? _ctx.t('upgrade_from_trial_button_text') : _ctx.t('upgrade_button_text')), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.isTrial ? _ctx.t('downgrade_from_trial_button_text') : _ctx.t('downgrade_button_text')), 1))
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["is-visible"]),
            (_ctx.currentStore)
              ? (_openBlock(), _createBlock(_component_StepperContent, {
                  key: 0,
                  "is-visible": _ctx.activeStep === 2
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isCustomSpendingLimitSetupFinished)
                      ? (_openBlock(), _createBlock(_component_FullWidthPanel, {
                          key: 0,
                          title: _ctx.t('step_two_title', { store: _ctx.currentStore?.name ?? '' }),
                          description: 
            _ctx.isUpgrade
              ? _ctx.t('step_two_upgrade_description', {
                  selectedPlan: _ctx.selectedPlanType && _ctx.getPlanName(_ctx.selectedPlanType),
                })
              : _ctx.t('step_two_downgrade_description', {
                  selectedPlan: _ctx.selectedPlanType && _ctx.getPlanName(_ctx.selectedPlanType),
                })
          
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_SelectCustomSpendingLimit, {
                              "selected-store": _ctx.currentStore,
                              "selected-plan": _ctx.selectedPlanType,
                              "min-limit": _ctx.minLimit,
                              "limit-types": _ctx.spendingLimitTypes,
                              "success-url": _ctx.successUrl,
                              onBack: _ctx.prevStep,
                              onSave: _ctx.nextStep
                            }, null, 8, ["selected-store", "selected-plan", "min-limit", "limit-types", "success-url", "onBack", "onSave"])
                          ]),
                          _: 1
                        }, 8, ["title", "description"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["is-visible"]))
              : _createCommentVNode("", true),
            (_ctx.currentStore)
              ? (_openBlock(), _createBlock(_component_StepperContent, {
                  key: 1,
                  "is-visible": _ctx.activeStep === 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FullWidthPanel, {
                      class: _normalizeClass({ success: _ctx.isCustomSpendingLimitSetupFinished }),
                      icon: _ctx.isCustomSpendingLimitSetupFinished ? undefined : 'mdi-alert-outline',
                      title: 
            _ctx.isCustomSpendingLimitSetupFinished
              ? _ctx.t('step_three_success_title')
              : _ctx.t('step_three_title')
          ,
                      description: 
            _ctx.isCustomSpendingLimitSetupFinished
              ? _ctx.t('step_three_success_description', {
                  limit: _ctx.currentStore.spendingLimit?.activeLimit ?? 0,
                  selectedPlan: _ctx.selectedPlanType && _ctx.getPlanName(_ctx.selectedPlanType),
                })
              : _ctx.t('step_three_description', {
                  store: _ctx.currentStore?.name ?? '',
                  selectedPlan: _ctx.selectedPlanType && _ctx.getPlanName(_ctx.selectedPlanType),
                })
          
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.isCustomSpendingLimitSetupFinished)
                          ? (_openBlock(), _createBlock(_component_ConfirmCustomSpendingLimit, {
                              key: 0,
                              "selected-store": _ctx.currentStore,
                              "selected-plan": _ctx.selectedPlanType,
                              onBack: _ctx.prevStep
                            }, null, 8, ["selected-store", "selected-plan", "onBack"]))
                          : (_openBlock(), _createBlock(_component_CustomSpendingLimitSuccess, {
                              key: 1,
                              "selected-store": _ctx.currentStore,
                              "selected-plan": _ctx.selectedPlanType,
                              onClose: _ctx.close
                            }, null, 8, ["selected-store", "selected-plan", "onClose"]))
                      ]),
                      _: 1
                    }, 8, ["class", "icon", "title", "description"])
                  ]),
                  _: 1
                }, 8, ["is-visible"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "show-stepper"])
      ], 64))
}